import React from 'react'
import { Box } from '../layout'
import './FlipCard.css'

export const FlipCard = ({ width, height, front, back, flipped, children, className, backRotate, ...props }) => {
  return (
    <Box className={`flip-card ${className ? className : ''}`} width={width} height={height}>
      <Box className="flip-card-inner" transform={flipped && 'rotateY(180deg)'}>
        {front &&
          <Box column className={`flip-card-front ${flipped ? 'hidden' : ''}`} {...props}>
            {front}
          </Box>
        }
        {back &&
          <Box column className={`flip-card-back ${!flipped ? 'hidden' : ''}`} {...props} rotate={backRotate}>
            {back}
          </Box>
        }
      </Box>
      {children}
    </Box>
  )
}